var _jsxFileName = "/codebuild/output/src2856833513/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/Banner/index.tsx";
import React from 'react';
import { Card, Stack, Text, VStack } from '@adc/parallax-component-library';
import { IconValidationInvalid } from '@adc/parallax-icons';
// TODO: according to designs it's supposed to handle RichText, which it doesn't now
const Banner = /*#__PURE__*/React.memo(({
  message,
  submessage,
  testID
}) => {
  return /*#__PURE__*/React.createElement(Card, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    flexDirection: "row",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(VStack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(IconValidationInvalid, {
    testID: `${testID}-banner-icon`,
    color: "$support.danger.surfaceOnColorAlt",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(VStack, {
    marginLeft: "$2",
    display: "flex",
    flex: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    type: "$bodyBase.default",
    textAlign: "left",
    nativeID: `${testID}-banner-message`,
    testID: `${testID}-banner-message`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 11
    }
  }, message), submessage && /*#__PURE__*/React.createElement(Text, {
    type: "$bodyBase.strong",
    textAlign: "left",
    nativeID: `${testID}-banner-submessage`,
    testID: `${testID}-banner-submessage`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 13
    }
  }, submessage))));
});
Banner.displayName = 'Banner';
export { Banner };